<template>
  <v-card>
    <v-card-title>
      <span class="headline">Suppression de {{ userName }} du four {{ ovenName }}</span>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12 v-if="displayCodeField">
            <v-text-field label="Code" v-model="code"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn color="black" flat large @click="$emit('close'); resetAll()">{{ $t('global.cancel') }}</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1" flat large @click="remove()">{{ $t('global.confirm') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>



<script>
export default {
  props: ["oven", "user"],
  data: () => ({
    code: null,
    displayCodeField: false
  }),
  computed: {
    ovenName() {
      if (!this.oven) {
        return "no oven";
      }
      return this.oven.name || this.oven.macAddress;
    },
    userName() {
      if (!this.user) {
        return "no user";
      }
      return this.user.name || this.user.email;
    }
  },
  watch: {
    oven() { }
  },
  methods: {
    resetAll() {
      this.displayCodeField = false;
      this.code = null;
    },
    // procédure
    async remove() {
      // si pas de code, demande de code
      if (!this.displayCodeField) {
        this.api
          .post("/clients/me/ovens/" + this.oven.id + "/code")
          .then(() => {
            this.displayCodeField = true;
          })
          .catch(err => {
            console.error(err);
          });
        return;
      }

      // dé-association
      this.api
        .delete(
          "/clients/me/ovens/" +
          this.oven.id +
          "/users/" +
          this.user.id +
          "?code=" +
          this.code
        )
        .then(() => {
          // recharge les utilisateurs
          this.$emit("reloadUserList");
          // cache la dialog
          this.$emit("close");
          // reset
          this.resetAll();
          // recharge la liste
          return this.$store.dispatch("loadOvenList");
        })
        .catch(err => {
          console.error(err.message);
        });
    }
  },
  mounted() { }
};
</script>
